import React from "react"

interface GtagProps {
  module?: string
}

type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[]
}

declare const window: WindowWithDataLayer

const Gtag: React.FC<GtagProps> = ({ module = "automotive" }) => {
  return (
    <>
      {module != "automotive" ? (
        <>
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=DC-15085953"
          ></script>
          <script>
            window.dataLayer = window.dataLayer || []; function gtag()
            {dataLayer.push(arguments)}
            gtag('js', new Date()); gtag('config', 'DC-15085953');
          </script>
        </>
      ) : (
        <></>
      )}
    </>
  )
}

export default Gtag
